import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { useData } from "../../hooks/useData";

// Premium loading screen shown once on first load. Brand-aware.
export default function Loader() {
  const { data: site } = useData("site");
  const [done, setDone] = useState(false);
  useEffect(() => {
    const t = setTimeout(() => setDone(true), 1300);
    return () => clearTimeout(t);
  }, []);

  const name = site?.siteName || "utipanagecy";

  return (
    <AnimatePresence>
      {!done && (
        <motion.div
          className="fixed inset-0 z-[10000] flex flex-col items-center justify-center bg-white"
          exit={{ opacity: 0, transition: { duration: 0.5 } }}
          data-testid="loader-screen"
        >
          <motion.div
            initial={{ opacity: 0, scale: 0.95 }} animate={{ opacity: 1, scale: 1 }} transition={{ duration: 0.5 }}
            className="text-3xl font-bold font-display tracking-tight text-gradient"
          >
            {name}
          </motion.div>
          <div className="mt-6 h-[3px] w-44 overflow-hidden rounded-full bg-slate-100">
            <motion.div className="h-full rounded-full bg-brand-gradient" initial={{ width: "0%" }} animate={{ width: "100%" }} transition={{ duration: 1.1, ease: "easeInOut" }} />
          </div>
          <p className="mt-4 text-xs uppercase tracking-[0.3em] text-slate-400">{site?.tagline?.split("•")[0]?.trim() || "Loading"}</p>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
